import { tv } from '@otomoro/helpers/mergeClasses'
import { VariantProps } from 'tailwind-variants'

export const styles = tv({
	slots: {
		wrapper: 'w-full flex justify-start items-center space-x-2 p-2 xl:p-3',
		badgeStyle: 'w-[4rem] h-[7rem] shrink-0',
		content: 'flex space-x-2 items-center',
		graphStyle: 'h-[9.5rem] w-[9.5rem] xl:w-[18.3rem] xl:h-[18.3rem] shrink-0',
		text: 'whitespace-pre-line !text-h3-mobile ',
	},
	variants: {
		moreElements: {
			true: {
				wrapper: 'xl:space-x-3',
				badgeStyle: 'xl:w-[6.5rem] xl:h-[11.4rem]',
				text: 'xl:!text-h2',
				content: 'xl:space-x-3',
			},
			false: {
				wrapper: 'xl:justify-center xl:space-x-[1.4rem] xl:items-start',
				badgeStyle: 'xl:w-[5rem] xl:h-[8.7rem]  xl:mt-[4.8rem]',
				content: 'xl:space-x-0 xl:flex-col ',
				text: 'xl:mt-2 xl:text-center xl:!text-h3',
			},
		},
	},
})

export type StylesVariants = VariantProps<typeof styles>
